import routeDetailModalV2 from '../routeDetailModalV2/routeDetailModalV2Handler';
import showCfdiHandler from '../cfdiModal/cfdiModalHandler';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import showConfirmation from '@waypoint/vue-confirmation';
import axios from 'axios';

import Multiselect from 'vue-multiselect';

import routeBoardEscl from '../locales/es-CL/routeBoard.json';
import routeBoardEsmx from '../locales/es-MX/routeBoard.json';
import routeBoardEsco from '../locales/es-CO/routeBoard.json';
import routeBoardEnus from '../locales/en-US/routeBoard.json';

export default {
  name: 'RouteBoard',
  i18n: {
    messages: {
      'es-CL': {
        routeBoard: routeBoardEscl,
      },
      'es-MX': {
        routeBoard: routeBoardEsmx,
      },
      'es-CO': {
        routeBoard: routeBoardEsco,
      },
      'en-US': {
        routeBoard: routeBoardEnus,
      },
    },
  },
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      filterOrderDate: 'asc',
      dateFilterIndex: 0,
      filterBoxDelay: false,
      filterBoxDocs: false,
      filterBoxDocsPartially: false,
      filterBoxEvents: false,
      isFilterShown: false,
      isFilterClicked: false,
      dataAccess: null,
      shortCutPath: null,
      isMainPageBussy: false,
      isButtonBussy: false,
      isButtonClicked: false,
      isFilterApplied: false,
      contactsVisible: false,
      selectedCollapse: false,
      routesDelayWarn: [],
      routeDocsNotdDone: [],
      routeDocsPartiallyDone: [],
      routesWithEvents: [],
      idRoute: null,
      nameFilterByUser: null,
      isNameFilterEmpty: false,
      selectedFilter: null,
      filtersByUser: [],
      filters: {
        locations: null,
        vehicle: null,
        driver: null,
        origin: null,
        destination: null,
        name: null,
        status: null,
        initRouteFrom: null,
        initRouteDuring: null,
        idRoute: null,
        documentNumber: null,
        tags: null,
        extraData: null,
      },
      options: {
        locations: [],
        vehicles: [],
        drivers: [],
        spots: [],
        names: [],
        status: [],
        initRouteFrom: [],
        initRouteDuring: [],
        idRoutes: [],
        documentList: [],
        tags: [],
        extraData: [],
      },
      routes: {
        notAssigned: [],
        assigned: [],
        onGoing: [],
        ended: [],
        notEnded: [],
      },
      header: null,
      sticky: null,
      rawRoutes: [],
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 300,
      refreshCountDown: 0,
      refreshCountDownStart: 30,
      initDateFrom: null,
      initDateTo: null,
      disableDateFilterIndex: false,
      timeoutID: null,
      configClient: null,
      cfdiList: [],
    };
  },
  /**@author Jorge Pizarro Tapia
   * Aqui comienza todo.
   */
  async created() {
    await this.prepareFilter();
    await this.prepareInstantFilter();
    await this.prepareInstantDetail();

    this.dataAccess = this.$store.getters.dataAccess;
    const client = this.$store.getters.client;
    if ((client && client.country === 'MX') || this.dataAccess.isSuperUser) {
      this.configClient = await this.getConfigClient();
      console.log('this.configClient', this.configClient);
    }
    this.isMainPageBussy = true;
    await this.prepareData();
    this.isMainPageBussy = false;
    this.autoRefresh();
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  methods: {
    async getCfdiList() {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            'x-api-key': this.$store.getters.clientApiKey,
          },
        };
        const url = `${this.$store.getters.urlCartaPorte}/route/cfdi`;
        const response = await axios.get(url, config);
        this.cfdiList = response.data.data;
        console.log('Lista de cfdis', this.cfdiList);
      } catch (e) {
        this.cfdiList = [];
        console.log(e);
      }
    },
    async getConfigClient() {
      try {
        const response = await axios.get(`${this.$store.getters.urlCartaPorte}/config`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          return response.data.data;
        } else {
          return null;
        }
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getAlerts() {
      const today = new Date().valueOf();
      const estadosValidos = [5, 6, 7];

      const rutasFiltradas = this.rawRoutes.filter((route) => estadosValidos.includes(route.status));

      let minStartDate = null;
      if (rutasFiltradas.length > 0) {
        minStartDate = rutasFiltradas.reduce((min, route) => {
          // Usa actualStartDate si existe, sino startDate
          const dateStr = route.actualStartDate || route.startDate;
          const start = new Date(dateStr).getTime();
          return start < min ? start : min;
        }, new Date(rutasFiltradas[0].actualStartDate || rutasFiltradas[0].startDate).getTime());
      } else {
        minStartDate = today - 86400000 * 5;
      }

      const urlAlert = `${this.$store.getters.urlAPI}/alert?startDateFilter=${minStartDate}&endDateFilter=${today}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const alertPromise = await axios.get(urlAlert, config);
        return alertPromise.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo encargado de preparar filtro instantaneo a las rutas.
     */
    async prepareInstantFilter() {
      this.shortCutPath = await this.$store.getters.shortCutPathOrigin;
      this.idRoute = await this.$store.getters.idRouteFlash;
      this.filters.initRouteFrom = await this.$store.getters.dateFilterFromRouteboard;
      this.filters.initRouteDuring = await this.$store.getters.dateFilterDuringRouteboard;
      this.$store.commit('cleanIdRouteFlash');
      this.$store.commit('cleanShortCutPathOrigin');
    },
    /**@author Jorge Pizarro Tapia
     * Metodo encargado de cargar detalles de una ruta dada una ID desde otra vista.
     */
    prepareInstantDetail() {
      if (this.idRoute !== null) {
        this.prepareRouteStatusDetail(this.idRoute);
        this.idRoute = null;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que carga los elementos de la vista que dependen de un token de sesion.
     * Esto es parte del proceso para evitar el problema de "carreras".
     */
    async prepareData() {
      await this.getCfdiList();
      await this.prepareRoutes(); //Carga de informacion principal de la vista: preparar las rutas.
      this.routeEvents = await this.getAlerts();
      this.populatePrincipalFilter(); //Carga de información de rutas a los filtros
      this.populateStatusFilter(); //Carga la lista de estados.
      this.populateInitRouteFilter(); //Carga la lista de rango de horas para inicio de ruta.
      this.filtersByUser = await this.getAllFilterByUser();
      await this.filterRoutes();
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de ubicaciones para el filtro.
     */
    populatePrincipalFilter() {
      this.rawRoutes.forEach((route) => {
        this.options.names.push(route.name);
        this.options.idRoutes.push(route.id);
        if (route.origin !== undefined) {
          this.options.spots.push(route.origin);
        }
        if (route.destination !== undefined) {
          this.options.spots.push(route.destination);
        }
        //Carga la información de vehículos y conductores
        this.populateDriverVehicleFilter(route);
        //Carga la información de los documentos
        this.populateDocumentFilter(route);
      });
      //Remueve elementos repetidos del resultado.
      this.options.names = this.options.names.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.options.spots = this.options.spots.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.options.idRoutes = this.options.idRoutes.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.options.documentList = this.options.documentList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.options.vehicles = this.options.vehicles.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.options.drivers = this.options.drivers.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.options.tags = this.options.tags.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.options.extraData = [...new Set(this.options.extraData)];
    },
    populateDriverVehicleFilter(route) {
      if (route.assignations !== undefined && route.assignations !== null && route.assignations.length > 0) {
        route.assignations.forEach((assign) => {
          if (assign.vehicle !== undefined) {
            if (assign.vehicle.id !== null || assign.vehicle.id !== undefined) {
              this.options.vehicles.push(assign.vehicle);
            }
          }
          if (assign.driver !== undefined) {
            if (assign.driver.id !== null || assign.driver.id !== undefined) {
              assign.driver.username =
                this.transformWords(assign.driver.firstName) + ' ' + this.transformWords(assign.driver.lastName);
              this.options.drivers.push(assign.driver);
            }
          }
        });
      }
    },
    populateDocumentFilter(route) {
      //Rellena los documentos
      if (route.trips !== undefined) {
        route.trips.forEach((trip) => {
          if (trip.extraData) {
            for (const value of Object.values(trip.extraData)) {
              this.options.extraData.push(value);
            }
          }
          trip.activities.forEach((activity) => {
            if (activity.tags) {
              this.options.tags = this.options.tags.concat(activity.tags);
            }
            activity.documents.forEach((document) => {
              this.options.documentList.push(document.number);
            });
          });
        });
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de rango de horas para inicion de ruta.
     */
    populateInitRouteFilter() {
      //Se establece limite de horas.
      let tempLimitDays = [];

      //Obtiene las lista de rango horario.
      let today = new Date();
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);

      //12 horas
      let hours = 12;
      tempLimitDays.push({
        rawHours: hours,
        last: this.dateToInteger(today) - 3600000 * hours,
        next: this.dateToInteger(today) + 3600000 * hours,
      });

      //24 horas
      hours = 24;
      tempLimitDays.push({
        rawHours: hours,
        last: this.dateToInteger(today) - 3600000 * hours,
        next: this.dateToInteger(today) + 3600000 * hours,
      });

      //48 horas
      hours = 48;
      tempLimitDays.push({
        rawHours: hours,
        last: this.dateToInteger(today) - 3600000 * hours,
        next: this.dateToInteger(today) + 3600000 * hours,
      });

      //72 horas
      hours = 72;
      tempLimitDays.push({
        rawHours: hours,
        last: this.dateToInteger(today) - 3600000 * hours,
        next: this.dateToInteger(today) + 3600000 * hours,
      });

      //Popula los filtros.
      this.options.initRouteFrom = [];
      this.options.initRouteDuring = [];
      tempLimitDays.forEach((day) => {
        this.options.initRouteFrom.push({
          name: this.$t(`routeBoard.filters.customOption.initRouteFrom`, { time: day.rawHours }),
          value: day.last,
        });
        this.options.initRouteDuring.push({
          name: this.$t(`routeBoard.filters.customOption.initRouteDuring`, { time: day.rawHours }),
          value: day.next,
        });
      });
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de estados.
     */
    populateStatusFilter() {
      //Obtiene todos los nombres de las rutas.
      const statusList = this.$t(`routeBoard.routeStatusOptions`);
      Object.entries(statusList).forEach((entry) => {
        const [key, value] = entry;
        this.options.status.push({
          id: parseInt(key),
          name: value,
        });
      });
    },
    /**@author Nicolas Sepulveda
     *  Metodo para ir a la vista de crear ruta masiva
     */
    openExcel() {
      localStorage.setItem('openExcel', true);
      this.$router.push({ name: 'Routes' });
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que obtiene las rutas desde el back-end, para luego administrarlas.
     */
    async prepareRoutes() {
      this.cleanRoutesManaged();
      await this.getStatusRoute(); //Obtiene la informacion.
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que obtiene las rutas desde el back-end.
     * @returns rutas, a traves de un array.
     */
    async getStatusRoute() {
      const urlRoutes = `${this.$store.getters.urlAPI}/route/status`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.get(urlRoutes, config);
        this.rawRoutes = routesPromise.data.data;
        return this.rawRoutes;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    deleteFilter() {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('routeBoard.filters.confirmation', { name: this.selectedFilter.name }),
        () => {
          this.deleteFilterByUser();
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async getAllFilterByUser() {
      const urlFilters = `${this.$store.getters.urlAPI}/filter/user/${this.$store.getters.loggedUser['idUser']}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.get(urlFilters, config);
        const filters = [];
        routesPromise.data.data.forEach((filter) => {
          filters.push({
            id: filter.id,
            name: filter.name,
            filtersJson: JSON.parse(filter.filtersJson),
          });
        });
        return filters;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async insertFilterByUser() {
      if (this.nameFilterByUser !== null) {
        this.isNameFilterEmpty = false;
        this.isButtonBussy = true;
        const body = {
          name: this.nameFilterByUser,
          nameView: this.$route.name,
          idUser: this.$store.getters.loggedUser['idUser'],
          filtersJson: JSON.stringify(this.filters),
        };
        const urlFilters = `${this.$store.getters.urlAPI}/filter/user`;
        try {
          const config = {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          };
          const routesPromise = await axios.post(urlFilters, body, config);
          let filter = routesPromise.data.data;
          filter.filtersJson = JSON.parse(filter.filtersJson);
          const filterBodyFront = {
            id: filter.id,
            name: filter.name,
            filtersJson: filter.filtersJson,
          };
          this.selectedFilter = filterBodyFront;
          this.filtersByUser.push(filterBodyFront);
          this.nameFilterByUser = null;
          this.isButtonBussy = false;
        } catch (e) {
          console.log(e);
          this.isButtonBussy = false;
        }
      } else {
        this.isNameFilterEmpty = true;
      }
    },
    async updateFilterByUser() {
      this.selectedFilter.filtersJson = this.filters;
      const body = {
        name: this.selectedFilter.name,
        nameView: this.$route.name,
        idUser: this.$store.getters.loggedUser['idUser'],
        filtersJson: JSON.stringify(this.selectedFilter.filtersJson),
      };
      const urlFilters = `${this.$store.getters.urlAPI}/filter/${this.selectedFilter.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.patch(urlFilters, body, config);
        const filterBd = routesPromise.data.data;
        this.filtersByUser.find((filterByUser) => {
          if (filterByUser.id === filterBd.id) {
            filterByUser.name = this.selectedFilter.name;
            filterByUser.filtersJson = this.selectedFilter.filtersJson;
            return filterByUser;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    async deleteFilterByUser() {
      this.isButtonBussy = true;
      const urlFilters = `${this.$store.getters.urlAPI}/filter/${this.selectedFilter.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const routesPromise = await axios.delete(urlFilters, config);
        if (routesPromise.data.status) {
          const index = this.filtersByUser.indexOf(this.selectedFilter.id);
          if (index >= 0) {
            this.filtersByUser.splice(index, 1);
          }
        }
        this.cleanFilter();
        this.selectedFilter = null;
        this.isButtonBussy = false;
      } catch (e) {
        console.log(e);
      }
    },
    getTotal(routeList) {
      if (routeList) {
        if (routeList.length > 9) {
          return routeList.length;
        } else {
          return '0' + routeList.length;
        }
      }
      return null;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que administra las rutas recibidas.
     * @param {Array} routes, es la lista de las rutas a administrar.
     */
    routeManager(routes) {
      //Desliza la pagina al inicio.
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.routesDelayWarn = [];
      this.routesWithEvents = [];
      this.routeDocsNotdDone = [];
      this.routeDocsPartiallyDone = [];
      routes.forEach((route) => {
        route.cfdiList = this.cfdiList[route.id] || [];
        /**@author Jorge Pizarro Tapia
         * La ruta cae en "rutas no asignadas" cuando esta en estado:
         * - SIN CONDUCTOR (1)
         */
        if (route.status === 1) {
          route.delayWarning = !this.checkRouteTimeDelayWithoutTrips(route);
          if (route.delayWarning) {
            this.routesDelayWarn.push(route);
          }
          this.routes.notAssigned.push(route);
        }

        /**@author Jorge Pizarro Tapia
         * La ruta cae en "rutas asignadas" cuando esta en estado:
         * - ASIGNADO PARCIAL (2)
         * - ASIGNADO (3)
         * - DESASIGNANDO (4)
         */
        if (route.status === 2 || route.status === 3 || route.status === 4) {
          route.delayWarning = !this.checkRouteTimeDelayWithoutTrips(route);
          if (route.delayWarning) {
            this.routesDelayWarn.push(route);
          }
          route.haveMoreAssignations = this.checkHaveAssignations(route);
          this.routes.assigned.push(route);
        }

        /**@author Jorge Pizarro Tapia
         * La ruta cae en "rutas en curso" cuando esta en estado:
         * - EN CURSO (5)
         */
        if (route.status === 5) {
          const cardsMetaData = this.getProgress(route, route.trips);
          route.progress = cardsMetaData.progressTrip;
          route.progressActivity = cardsMetaData.progressActivity;
          route.delayWarning = !this.checkRouteTimeDelay(route);
          if (route.delayWarning) {
            this.routesDelayWarn.push(route);
          }
          route.haveMoreAssignations = this.checkHaveAssignations(route);
          const existEvent = this.routeEvents.find((event) => event.idRoute === route.id);
          if (existEvent) {
            route.haveEvents = true;
            this.routesWithEvents = this.routesWithEvents.concat(existEvent);
          }
          route.docsNotDone = cardsMetaData.documentNotDone;
          route.documentPartiallyDone = cardsMetaData.documentPartiallyDone;
          this.routes.onGoing.push(route);
        }

        /**@author Jorge Pizarro Tapia
         * La ruta cae en "rutas finalizadas" cuando esta en estado:
         * - FINALIZADO COMPLETO (6)
         * - FINALIZADO INCOMPLETO (7)
         */
        if (route.status === 6 || route.status === 7) {
          const cardsMetaData = this.getProgress(route, route.trips);
          route.progress = cardsMetaData.progressTrip;
          route.progressActivity = cardsMetaData.progressActivity;

          route.haveMoreAssignations = this.checkHaveAssignations(route);
          const existEvent = this.routeEvents.find((event) => event.idRoute === route.id);
          if (existEvent) {
            route.haveEvents = true;
            this.routesWithEvents = this.routesWithEvents.concat(existEvent);
          }
          route.docsNotDone = cardsMetaData.documentNotDone;
          route.documentPartiallyDone = cardsMetaData.documentPartiallyDone;
          this.routes.ended.push(route);
        }

        /**@author Jorge Pizarro Tapia
         * La ruta cae en "rutas no realizadas" cuando esta en estado:
         * - NO REALIZADO (8)
         * - CANCELADO (9)
         */
        if (route.status === 8 || route.status === 9) {
          route.haveMoreAssignations = this.checkHaveAssignations(route);
          this.routes.notEnded.push(route);
        }
      });
      if (this.filterBoxDelay || this.filterBoxDocs || this.filterBoxEvents || this.filterBoxDocsPartially) {
        this.routesDelayWarn = [];
        this.routeDocsNotdDone = [];
        this.routesWithEvents = [];
        this.routeDocsPartiallyDone = [];
        this.routes.notAssigned = this.filterDelayAndDocs(this.routes.notAssigned);
        this.routes.assigned = this.filterDelayAndDocs(this.routes.assigned);
        this.routes.onGoing = this.filterDelayAndDocs(this.routes.onGoing);
        this.routes.ended = this.filterDelayAndDocs(this.routes.ended);
        this.routes.notEnded = this.filterDelayAndDocs(this.routes.notEnded);
      }
    },
    filterDelayAndDocs(routeList) {
      routeList = routeList.filter((route) => {
        let isRouteFilter = false;
        if (this.filterBoxDelay && route.delayWarning) {
          this.routesDelayWarn.push(route);
          isRouteFilter = true;
        }
        if (
          this.filterBoxDocs &&
          ((route.docsNotDone && route.docsNotDone !== undefined) ||
            (!route.activityDone && route.activityDone !== undefined))
        ) {
          this.routeDocsNotdDone.push(route);
          isRouteFilter = true;
        }
        if (
          this.filterBoxDocsPartially &&
          ((route.documentPartiallyDone && route.documentPartiallyDone !== undefined) ||
            (route.activityPartiallyDone && route.activityPartiallyDone !== undefined))
        ) {
          this.routeDocsPartiallyDone.push(route);
          isRouteFilter = true;
        }
        if (this.filterBoxEvents && route.haveEvents && route.haveEvents !== undefined) {
          this.routesWithEvents.push(route);
          isRouteFilter = true;
        }
        if (isRouteFilter) {
          return route;
        }
      });
      return routeList;
    },
    checkHaveAssignations(route) {
      let haveAssignations = false;
      try {
        if (route.assignations !== undefined) {
          if (route.assignations.length > 1) {
            haveAssignations = true;
          }
        }
        return haveAssignations;
      } catch (e) {
        return haveAssignations;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que calcula el progreso de una ruta.
     * @param {Array} trips, los viajes de la ruta.
     * @returns el progreso en porcentaje.
     */
    getProgress(route, trips) {
      let doneTrips = 0;
      let totalTrips = 0;
      let doneActivity = 0;
      let totalActivity = 0;
      let activtyNotDone = false;
      let activityPartiallyDone = false;
      let documentNotDone = false;
      let documentPartiallyDone = false;
      route.activityDone = true;
      route.activityPartiallyDone = false;
      trips.forEach((trip) => {
        if (trip.state === 'ENDED') {
          doneTrips++;
        }
        totalTrips++;
        if (trip.activities) {
          trip.activities.forEach((activity) => {
            if (activity.state === 'DONE') {
              doneActivity++;
            }
            totalActivity++;
            ({ activtyNotDone, activityPartiallyDone, documentNotDone, documentPartiallyDone } =
              this.checkDocumentsDone(
                route,
                activity,
                activtyNotDone,
                activityPartiallyDone,
                documentNotDone,
                documentPartiallyDone,
              ));
          });
        }
      });
      if (activtyNotDone || documentNotDone) {
        this.routeDocsNotdDone.push(route);
      }
      if (activityPartiallyDone || documentPartiallyDone) {
        this.routeDocsPartiallyDone.push(route);
      }
      return {
        documentNotDone: documentNotDone,
        documentPartiallyDone: documentPartiallyDone,
        progressTrip: Math.round((doneTrips / totalTrips) * 100) + '%',
        progressActivity: Math.round((doneActivity / totalActivity) * 100) + '%',
      };
    },
    checkDocumentsDone(route, activity, activtyNotDone, activityPartiallyDone, documentNotDone, documentPartiallyDone) {
      //Si posee documentos veo el estado de documentos
      if (activity.documents !== undefined && activity.documents.length > 0) {
        activity.documents.forEach((document) => {
          if (document.state === 'NOTDONE') {
            documentNotDone = true;
          } else if (document.state === 'PARTIALLYDONE') {
            documentPartiallyDone = true;
          }
        });
      } else {
        //Caso contrario que no posea documentos, veo el estado de la actividad
        if (activity.state === 'NOTDONE') {
          activtyNotDone = true;
          route.activityDone = false;
        } else if (activity.state === 'PARTIALLYDONE') {
          activityPartiallyDone = true;
          route.activityPartiallyDone = true;
        }
      }
      return {
        activtyNotDone,
        activityPartiallyDone,
        documentNotDone,
        documentPartiallyDone,
      };
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que obtiene los datos de una direccion y retorna su calle, numeor y region.
     * @param {String} originAddress, es la direccion de origen de una ruta.
     * @returns Direccion #Numero, Region
     */
    getRouteAddressOrigin(route) {
      if (route.origin && route.origin.address) {
        const originAddress = route.origin.address;
        return originAddress.street + ', ' + originAddress.state;
      }
      return 'no encontrado';
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que obtiene una ruta, y extrae el conductor/vehículo.
     * @param {Route} route, de la cual se obtendra conductor/vehículo.
     * @returns {String} conductor - patente (Si posee).
     */
    getDriverVehicle(route) {
      let result = '';
      //Verifica la existencia del vehículo/conductor en la ruta.
      if (route.driver !== undefined && route.vehicle !== undefined) {
        result =
          this.transformWords(route.driver.firstName) +
          ' ' +
          this.transformWords(route.driver.lastName) +
          ' - ' +
          route.vehicle.plate;
      } else {
        if (route.driver !== undefined) {
          result = this.transformWords(route.driver.firstName) + ' ' + this.transformWords(route.driver.lastName);
        }
        if (route.vehicle !== undefined) {
          result = route.vehicle.plate;
        }
      }
      return result;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que recibe el ID del estado de ruta y lo traduce a texto.
     * @param {Integer} statusRoute, identificar del estado de ruta.
     * @returns {String}, nombre del estado.
     */
    parseStatusRoute(statusRoute) {
      return this.$t(`routeBoard.routeStatusOptions.${statusRoute}`);
    },
    /**@author Nicolás Sepúlveda Valdivia
     * Metodo que verifica si los documentos de una ruta tienen el estado no realizado
     * @param {Route} route es la ruta a revisar
     * @returns true: documento con estado distinto a NOT DONE ; false: Estado del documento NOT DONE
     */

    isParciallyDocument(trip) {
      for (let activity of trip.activities) {
        for (let document of activity.documents) {
          if (document.state === 'PARTIALLYDONE') {
            return true;
          }
        }
      }
      return false;
    },

    /**@author Nicolás Sepúlveda Valdivia
     * Metodo que verifica si los documentos de una ruta tienen el estado no realizado
     * @param {Route} route es la ruta a revisar
     * @returns true: documento con estado distinto a NOT DONE ; false: Estado del documento NOT DONE
     */
    checkActivityDone(route) {
      var activityDone = null;
      //Verifico si la ruta posee viajes asignados
      if (route.trips !== undefined && route.trips.length > 0) {
        //Viajo hasta llegar a los documentos de la ruta, esto significa revisar cada viaje, sus actividades, y luego sus documentos
        route.trips.forEach((trip) => {
          if (trip.activities !== undefined && trip.activities.length > 0) {
            trip.activities.forEach((activitie) => {
              if (activitie.state === 'NOTDONE') {
                activityDone = false;
              }
            });
          }
        });
      }
      return activityDone === null ? true : activityDone;
    },
    /**@author Nicolás Sepúlveda Valdivia
     * Metodo que verifica si una ruta tiene retraso evaluando la fecha de comienzo de ruta
     * @param {Route} route es la ruta a revisar
     * @returns true: esta a tiempo; false: esta con retraso
     */
    checkRouteTimeDelayWithoutTrips(route) {
      //Se obtiene la fecha actual.
      const today = new Date();
      const currentSeconds = today.getTime();
      const extraTime = 900000; //Tiempo extra (15 minutos).

      let isRouteInTime = null; //Verificador de tiempo de una ruta.

      const startLimit = new Date(route.startDate);
      const startLimitSeconds = startLimit.getTime() + extraTime;
      //Verifica si la ruta esta atrasada o no con respecto a su hora de inicio
      if (currentSeconds > startLimitSeconds) {
        isRouteInTime = false;
      } else {
        isRouteInTime = true;
      }
      return isRouteInTime === null ? true : isRouteInTime;
    },

    /**@author Jorge Pizarro Tapia
     * Metodo que verifica si la ruta tiene retraso.
     * @param {Route} route, es la ruta a revisar.
     * @returns true: esta a tiempo; false: esta con retraso.
     */
    checkRouteTimeDelay(route) {
      //Se obtiene la fecha actual.
      const today = new Date();
      const currentSeconds = today.getTime();
      const extraTime = 900000; //Tiempo extra (15 minutos).

      let isRouteInTime = null; //Verificador de tiempo de una ruta.

      route.trips = this.sortRouteTrips(route.trips);

      route.trips.forEach((trip) => {
        //Si el viaje no ha sido iniciado:
        if ('NOTSTARTED' === trip.state) {
          //Verifica que la hora actual no sobrepase la hora de inicio programada.
          const startLimit = new Date(trip.startDate);
          const startLimitSeconds = startLimit.getTime() + extraTime;

          //Si la hora actual sobrepasa la hora de inicio programada: hay retraso.
          if (currentSeconds > startLimitSeconds) {
            isRouteInTime = false;
          }
        }

        //Si el viaje esta en transito o ha terminado:
        if ('ENDED' === trip.state) {
          //Verifica que la hora iniciada no haya sobrepasado la hora de inicio programada.
          const startLimit = new Date(trip.startDate);
          const startLimitSeconds = startLimit.getTime() + extraTime;

          const initiatedTrip = new Date(trip.actualStartDate);
          const initiatedSeconds = initiatedTrip.getTime();

          //Si la hora iniciada sobrepaso la hora de inicio programada: hubo retraso.
          if (initiatedSeconds > startLimitSeconds) {
            isRouteInTime = false;
          }

          //Verifica que la hora terminada no haya sobrepasado la hora de termino programada.
          const endLimit = new Date(trip.endDate);
          const endLimitSeconds = endLimit.getTime() + extraTime;

          const terminatedTrip = new Date(trip.actualEndDate);
          const terminatedSeconds = terminatedTrip.getTime();

          //Si la hora terminada sobrepaso la hora de termino programada: hubo retraso.
          if (terminatedSeconds > endLimitSeconds) {
            isRouteInTime = false;
          }
        }
        //Si el viaje esta en transito:
        if ('INTRANSIT' === trip.state) {
          //Verifica que la hora actual no sobrepase la hora de termino programada.
          const endLimit = new Date(trip.endDate);
          const endLimitSeconds = endLimit.getTime() + extraTime;

          //Si la hora actual sobrepasa la hora de termino programada: hay retraso.
          if (currentSeconds > endLimitSeconds) {
            isRouteInTime = false;
          } else {
            isRouteInTime = true;
          }
        }
      });
      return isRouteInTime === null ? true : isRouteInTime;
    },
    openCfdiModal(route, canCreateCFDI) {
      this.isButtonClicked = true;
      showCfdiHandler(this.configClient, null, null, route, canCreateCFDI, this.updateListCfdiRoute);
    },
    /**
     * Metodo que se encarga de actualizar el numero de cfdi que tiene una ruta cuando cierro el modal de creación cfdiModal
     * Solo si es que la ruta pertenece a una en curso o asignada
     * @param {*} route Esta ruta es la que envia el componente del modal, viene actualizada con los listados de cfdi
     */
    updateListCfdiRoute(route) {
      if (route.status === 2 || route.status === 3 || route.status === 4) {
        this.updateCfdiRoute(this.routes.assigned, route);
      }
      if (route.status === 5) {
        this.updateCfdiRoute(this.routes.onGoing, route);
      }
    },
    updateCfdiRoute(list, route) {
      list.forEach((item, index) => {
        if (item.id === route.id) {
          this.$set(list, index, {
            ...item,
            cfdiList: route.cfdiList,
          });
        }
      });
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que ordena los viajes segun su hora de inicio programada.
     * @param {Array} trips, los viajes a ordenar.
     * @returns {Array} trips ordenados.
     */
    sortRouteTrips(trips) {
      trips = trips.sort((a, b) => {
        if (this.dateToInteger(a.startDate) > this.dateToInteger(b.startDate)) {
          return 1;
        }
        if (this.dateToInteger(b.startDate) > this.dateToInteger(a.startDate)) {
          return -1;
        }
        return 0;
      });
      return trips;
    },
    async filterByDelay() {
      this.isMainPageBussy = true;
      this.filterBoxDelay = !this.filterBoxDelay;
      await this.filterRoutes();
      this.isMainPageBussy = false;
    },
    async filterByDocsNotDone() {
      this.isMainPageBussy = true;
      this.filterBoxDocs = !this.filterBoxDocs;
      await this.filterRoutes();
      this.isMainPageBussy = false;
    },

    async filterBoxDocsPartiallyDone() {
      this.isMainPageBussy = true;
      this.filterBoxDocsPartially = !this.filterBoxDocsPartially;
      await this.filterRoutes();
      this.isMainPageBussy = false;
    },
    async filterByEvents() {
      this.isMainPageBussy = true;
      this.filterBoxEvents = !this.filterBoxEvents;
      await this.filterRoutes();
      this.isMainPageBussy = false;
    },
    changeFilter() {
      if (this.selectedFilter) {
        this.filters = {
          ...this.filters,
          ...this.selectedFilter.filtersJson,
        };
      }
    },
    /**
     * metodo que cambia el orden de las rutas por fecha
     */
    async switchOrder() {
      this.isMainPageBussy = true;
      if (this.filterOrderDate === 'asc') {
        this.filterOrderDate = 'desc';
        this.rawRoutes.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
        await this.filterRoutes();
      } else {
        this.filterOrderDate = 'asc';
        this.rawRoutes.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        await this.filterRoutes();
      }
      this.isMainPageBussy = false;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que se encarga de filtrar las columnas de la vista.
     */
    async filterRoutes() {
      this.saveDateFilter(); //Se almacena el filtro de fecha en memoria.
      //Limpiar columnas.
      this.cleanRoutesManaged();
      //Filtrar cada columna.
      let tempRoutes = this.rawRoutes;
      this.isFilterApplied = false;
      //Filtrar por patente de vehículo.

      if (
        (this.filters.driver !== null && this.filters.driver.length > 0) ||
        (this.filters.vehicle !== null && this.filters.vehicle.length > 0)
      ) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.assignations !== undefined && route.assignations !== null && route.assignations.length > 0) {
            return this.filterByDriverVehicle(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.origin !== null && this.filters.origin.length > 0) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.origin !== undefined) {
            return this.filterOrigin(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.destination !== null && this.filters.destination.length > 0) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.destination !== undefined) {
            this.filterDestination(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.name !== null && this.filters.name.length > 0) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.name !== undefined) {
            return this.filterRouteName(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.status !== null && this.filters.status.length > 0) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.status !== undefined) {
            return this.filterRouteStatus(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      //Trae todas las rutas que sean del pasado, segun un intervalo de tiempo, ya sea 24, 48, o 72 horas, valida su fecha de inicio
      if (this.filters.initRouteFrom !== null) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.startDate !== undefined) {
            return this.filterInitRouteFrom(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      //Trae todas las rutas que sean del futuro, segun un intervalo de tiempo, ya sea 24, 48, o 72 horas, valida su fecha de inicio
      if (this.filters.initRouteDuring !== null) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.startDate !== undefined) {
            return this.filterInitRouteDuring(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.initDateFrom !== null) {
        tempRoutes = tempRoutes.filter((route) => {
          return this.filterInitDate(route);
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.initDateTo !== null) {
        tempRoutes = tempRoutes.filter((route) => {
          return this.filterInitDateTo(route);
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.idRoute !== null && this.filters.idRoute.length > 0) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.id !== undefined) {
            return this.filterRouteId(route);
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (
        (this.filters.tags && this.filters.tags.length > 0) ||
        (this.filters.extraData && this.filters.extraData.length > 0) ||
        (this.filters.documentNumber && this.filters.documentNumber.length > 0)
      ) {
        tempRoutes = tempRoutes.filter((route) => {
          this.isFilterApplied = true;
          let idFilterRoute = this.filterExtraDataTagAndDocument(route);
          return idFilterRoute.some((filterExtraDataTagDoc) => {
            return route.id === filterExtraDataTagDoc;
          });
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      this.routeManager(tempRoutes);
    },
    filterByDriverVehicle(route) {
      this.isFilterApplied = true;
      let filteredVehicle = true;
      let filteredDriver = true;
      return route.assignations.some((assign) => {
        if (this.filters.vehicle !== null && this.filters.vehicle.length > 0 && assign.vehicle !== undefined) {
          filteredVehicle = this.filters.vehicle.some((vehicle) => {
            if (vehicle !== undefined) {
              return assign.vehicle.id === vehicle.id;
            }
          });
        }
        if (this.filters.driver !== null && this.filters.driver.length > 0 && assign.driver !== undefined) {
          filteredDriver = this.filters.driver.some((driver) => {
            if (driver !== undefined) {
              return assign.driver.id === driver.id;
            }
          });
        }
        return filteredVehicle && filteredDriver;
      });
    },
    filterOrigin(route) {
      this.isFilterApplied = true;
      return this.filters.origin.some((origin) => {
        if (origin !== undefined) {
          return origin.id === route.origin.id;
        }
      });
    },
    filterDestination(route) {
      this.isFilterApplied = true;
      return this.filters.destination.some((destination) => {
        if (destination !== undefined) {
          return destination.id === route.destination.id;
        }
      });
    },
    filterRouteName(route) {
      this.isFilterApplied = true;
      return this.filters.name.some((name) => {
        if (name !== undefined) {
          return name === route.name;
        }
      });
    },
    filterRouteStatus(route) {
      this.isFilterApplied = true;
      return this.filters.status.some((status) => {
        if (status !== undefined) {
          return status.id === route.status;
        }
      });
    },
    filterInitRouteFrom(route) {
      this.isFilterApplied = true;
      //Obtiene las lista de rango horario.
      let today = new Date();
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      if (
        this.filters.initRouteFrom.value <= this.dateToInteger(route.startDate) &&
        this.dateToInteger(today) >= this.dateToInteger(route.startDate)
      ) {
        return route;
      }
    },
    filterInitRouteDuring(route) {
      this.isFilterApplied = true;
      //Obtiene las lista de rango horario.
      let today = new Date();
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      if (
        this.filters.initRouteDuring.value >= this.dateToInteger(route.startDate) &&
        this.dateToInteger(today) <= this.dateToInteger(route.startDate)
      ) {
        return route;
      }
    },
    filterInitDate(route) {
      this.isFilterApplied = true;
      if (this.dateToInteger(this.initDateFrom) <= this.dateToInteger(route.startDate)) {
        return route;
      }
    },
    filterInitDateTo(route) {
      this.isFilterApplied = true;
      if (this.dateToInteger(this.initDateTo) >= this.dateToInteger(route.startDate)) {
        return route;
      }
    },
    filterRouteId(route) {
      this.isFilterApplied = true;
      return this.filters.idRoute.some((idRoute) => {
        if (idRoute !== undefined) {
          return idRoute === route.id;
        }
      });
    },
    filterExtraDataTagAndDocument(route) {
      let filterData = [];
      if (route.trips !== undefined) {
        for (const trip of route.trips) {
          if (
            this.filters.extraData &&
            trip.extraData &&
            Object.values(trip.extraData).includes(this.filters.extraData)
          ) {
            filterData.push(route.id);
          }
          if (
            trip.activities !== undefined &&
            ((this.filters.tags && this.filters.tags.length > 0) ||
              (this.filters.documentNumber && this.filters.documentNumber.length > 0))
          ) {
            filterData = this.filterTagAndDocument(route.id, filterData);
          }
        }
      }
      return filterData;
    },
    filterTagAndDocument(idRoute, trip, filterData) {
      for (const activity of trip.activities) {
        if (activity.tags && activity.tags.length > 0) {
          activity.tags.some((tag) => {
            this.filters.tags.some((filterTag) => {
              if (tag.id === filterTag.id) {
                return filterData.push(idRoute);
              }
            });
          });
        }
        if (activity.documents !== undefined && this.filters.documentNumber && this.filters.documentNumber.length > 0) {
          filterData = this.filterDocument(idRoute, filterData);
        }
        return filterData;
      }
    },
    filterDocument(idRoute, activity, filterData) {
      for (const document of activity.documents) {
        this.filters.documentNumber.filter((filterDoc) => {
          if (document.number === filterDoc) {
            return filterData.push(idRoute);
          }
        });
      }
      return filterData;
    },
    limitText(count) {
      return this.$t('routeBoard.search.limitText') + (count + 1);
    },
    validateDataDriver(driver) {
      if (driver) {
        return this.transformWords(driver.firstName) + ' ' + this.transformWords(driver.lastName);
      }
      return ' ';
    },
    validateDataVehicle(vehicle) {
      if (vehicle) {
        return vehicle.plate;
      }
      return ' ';
    },
    /**
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord === '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    /**
     * Metodo que guarda el filtro de fecha en memoria.
     */
    saveDateFilter() {
      this.$store.commit('saveDateFilterFromRouteboard', this.filters.initRouteFrom);
      this.$store.commit('saveDateFilterDuringRouteboard', this.filters.initRouteDuring);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que limpia los arreglos de las rutas.
     */
    cleanRoutesManaged() {
      this.routes.notAssigned = [];
      this.routes.assigned = [];
      this.routes.onGoing = [];
      this.routes.ended = [];
      this.routes.notEnded = [];
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que muestra los detalles de una ruta dada su id.
     * @param {Integer} idRoute, es el id del a ruta.
     */
    async prepareRouteStatusDetail(idRoute) {
      let events = [];

      this.routeEvents.forEach((event, index) => {
        if (event.idRoute === idRoute) {
          //Alerta de panico
          if (event.alertType === 102) {
            event.eventType = 109;
          }
          //Alerta de Jammer
          if (event.alertType === 103) {
            event.eventType = 108;
          }
          event.nameEvent = this.$t(`common.eventTypesOptions[${event.eventType - 101}]`);
          event.eventId = index + event.eventId;
          events.push(event);
        }
      });
      if (!this.isButtonClicked) {
        await this.$store.commit('saveRouteDetailCounter', this.autoRefreshTimer);
        routeDetailModalV2(idRoute, events);
        this.isButtonClicked = false;
      } else {
        this.isButtonClicked = false;
      }
    },
    toogleCollapse(idCollapse) {
      this.isButtonClicked = true;
      this.$root.$emit('bv::toggle::collapse', idCollapse);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que ajusta el tamano del contador de rutas.
     * @param {Integer} routes, es la cantidad de rutas de la columna.
     * @returns {String} el ancho del cuadro del contador.
     */
    setRouteCounterBox(routes) {
      let width = 25;
      if (routes > 999) {
        width = 40;
      } else if (routes > 99) {
        width = 35;
      }
      return 'width: ' + width + 'px;';
    },
    /**
     * Funciones para desactivar el filtro clickeando fuera de la pantalla
     */
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que deriva a otra vista dado ciertos parametros.
     * Prioridad al cambiar de vista: Preparar filtrado instantaneo por id de ruta.
     * @param {Integer} routeId, es la id de la ruta seleccionada.
     * @param {String} path, es el nombre de la vista a la que se desea ir.
     * @returns A la nueva vista.
     */
    async goToAnotherPage(routeId, path) {
      this.isButtonClicked = true;
      await this.$store.commit('saveShortCutPathOrigin', 'RouteBoard');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que retorna a la vista anterior.
     * @param {String} shortCutPath, nombre de la ruta.
     * @returns vista anterior.
     */
    returnToPage(shortCutPath) {
      return this.$router.push({ name: shortCutPath });
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que recibe una fecha, y retorna un String del mismo.
     * @param {Date} date, es la fecha en formato timestamp.
     * @returns String con formato 'dd/mm hh:mm'.
     */
    parseDate(date) {
      const seconds = this.dateToInteger(date);
      const dateTemp = new Date(seconds);
      const rawMonth = dateTemp.getMonth() + 1 < 10 ? '0' + (dateTemp.getMonth() + 1) : dateTemp.getMonth() + 1;
      const rawDay = dateTemp.getDate() < 10 ? '0' + dateTemp.getDate() : dateTemp.getDate();
      const rawHour = dateTemp.getHours() < 10 ? '0' + dateTemp.getHours() : dateTemp.getHours();
      const rawMinute = dateTemp.getMinutes() < 10 ? '0' + dateTemp.getMinutes() : dateTemp.getMinutes();
      return rawDay + '/' + rawMonth + ' ' + rawHour + ':' + rawMinute;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que parsea la fecha en segundos.
     * @param {String} date es la fecha a parsear.
     * @returns la fecha en segundos.
     */
    dateToInteger(date) {
      const dateTemp = new Date(date);
      return dateTemp.getTime();
    },
    //Metodo exclusivo del autorefrescador y el refresco forzado de la rutas.
    async loadRoutes() {
      this.isMainPageBussy = true;
      await this.getCfdiList();
      await this.prepareRoutes(); //Carga de informacion principal de la vista: preparar las rutas.
      this.populatePrincipalFilter(); //Carga de información de rutas a los filtros
      this.filtersByUser = await this.getAllFilterByUser();
      await this.filterRoutes();
      this.isMainPageBussy = false;
    },
    /**
     * Metodo que incrementa el indice de filtro de fechas.
     * NOTA1: El valor negativo corresponde al filtro "Desde" y el valor positivo al filtro "Durante".
     * NOTA2: El rango depende de las opciones que tenga cada filtro.
     */
    increaseDateFilterIndex() {
      if (this.dateFilterIndex < 3) {
        this.dateFilterIndex++;
        this.setDateFilterRoute();
      }
    },
    /**
     * Metodo que disminuye el indice de filtro de fechas.
     * NOTA1: El valor negativo corresponde al filtro "Desde" y el valor positivo al filtro "Durante".
     * NOTA2: El rango depende de las opciones que tenga cada filtro.
     */
    decreaseDateFilterIndex() {
      if (this.dateFilterIndex > -3) {
        this.dateFilterIndex--;
        this.setDateFilterRoute();
      }
    },
    /**
     * Metodo que setea el filtro de fechas.
     */
    setDateFilterRoute() {
      if (this.dateFilterIndex < 0) {
        this.filters.initRouteFrom = this.options.initRouteFrom[Math.abs(this.dateFilterIndex)];
        this.filters.initRouteDuring = null;
      } else if (this.dateFilterIndex > 0) {
        this.filters.initRouteDuring = this.options.initRouteDuring[Math.abs(this.dateFilterIndex)];
        this.filters.initRouteFrom = null;
      } else {
        this.filters.initRouteFrom = null;
        this.filters.initRouteDuring = null;
      }
      this.filterRoutes();
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que refresca el contenido de la vista cada cierto tiempo.
     */
    autoRefresh() {
      if (this.$route.name !== 'RouteBoard') {
        return;
      }
      if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
        this.timeoutID = setTimeout(() => {
          this.autoRefreshTimer += 1;
          this.autoRefresh();
        }, 1000);
      } else {
        this.autoRefreshTimer = 0;
        this.loadRoutes();
        this.autoRefresh();
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que fuerza el refresco de las rutas.
     */
    startCountDownTimer() {
      this.refreshCountDown = this.refreshCountDownStart;
      this.loadRoutes();
      this.autoRefreshTimer = 0;
      this.countDownTimer();
    },
    /**@author Jorge Pizarro Tapia
     * Contador que mantiene deshabilitado en boton de refresco de rutas forzado.
     */
    countDownTimer() {
      if (this.refreshCountDown > 0) {
        setTimeout(() => {
          this.refreshCountDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    useDateFilter() {
      this.$store.commit('saveInitDateFrom', this.initDateFrom);
      this.$store.commit('saveInitDateTo', this.initDateTo);
      if (this.initDateFrom !== null || this.initDateTo !== null) {
        this.disableDateFilterIndex = true;
        this.filters.initRouteFrom = null;
        this.filters.initRouteDuring = null;
        this.dateFilterIndex = 0;
      } else {
        this.disableDateFilterIndex = false;
      }
      this.filterRoutes();
    },
    useFilter() {
      this.$store.commit('saveRouteBoardVehicleFilter', this.filters.vehicle);
      this.$store.commit('saveRouteBoardDriverFilter', this.filters.driver);
      this.$store.commit('saveRouteBoardOriginFilter', this.filters.origin);
      this.$store.commit('saveRouteBoardDestinationFilter', this.filters.destination);
      this.$store.commit('saveRouteBoardRouteNameFilter', this.filters.name);
      this.$store.commit('saveRouteBoardRouteStatusFilter', this.filters.status);
      this.$store.commit('saveRouteBoardRouteIdFilter', this.filters.idRoute);
      this.$store.commit('saveRouteBoardDocumentNumberFilter', this.filters.documentNumber);
    },
    prepareFilter() {
      this.filters.vehicle = this.$store.getters.routeBoardVehicleFilter;
      this.filters.driver = this.$store.getters.routeBoardDriverFilter;
      this.filters.origin = this.$store.getters.routeBoardOriginFilter;
      this.filters.destination = this.$store.getters.routeBoardDestinationFilter;
      this.filters.name = this.$store.getters.routeBoardRouteNameFilter;
      this.filters.status = this.$store.getters.routeBoardRouteStatusFilter;
      this.filters.idRoute = this.$store.getters.routeBoardRouteIdFilter;
      this.filters.documentNumber = this.$store.getters.routeBoardDocumentNumberFilter;
      this.initDateFrom = this.$store.getters.initDateFrom;
      this.initDateTo = this.$store.getters.initDateTo;
    },
    /**
     * Metodo que limpia el filtrado.
     */
    cleanFilter() {
      this.filters.vehicle = null;
      this.filters.driver = null;
      this.filters.origin = null;
      this.filters.destination = null;
      this.filters.name = null;
      this.filters.status = null;
      this.filters.idRoute = null;
      this.filters.documentNumber = null;
      this.filters.tags = null;
      this.initDateFrom = null;
      this.initDateTo = null;
      this.filters.initRouteFrom = null;
      this.filters.initRouteDuring = null;
      this.filters.extraData = null;
      this.$store.commit('saveRouteBoardVehicleFilter', this.filters.vehicle);
      this.$store.commit('saveRouteBoardDriverFilter', this.filters.driver);
      this.$store.commit('saveRouteBoardOriginFilter', this.filters.origin);
      this.$store.commit('saveRouteBoardDestinationFilter', this.filters.destination);
      this.$store.commit('saveRouteBoardRouteNameFilter', this.filters.name);
      this.$store.commit('saveRouteBoardRouteStatusFilter', this.filters.status);
      this.$store.commit('saveRouteBoardRouteIdFilter', this.filters.idRoute);
      this.$store.commit('saveRouteBoardDocumentNumberFilter', this.filters.documentNumber);
      this.$store.commit('saveInitDateFrom', this.initDateFrom);
      this.$store.commit('saveInitDateTo', this.initDateTo);
      this.disableDateFilterIndex = false;
      this.filterRoutes();
    },
  },
  computed: {
    minDate() {
      //YYYY-MM-DD HH:MM:SS en 24 horas format
      var minDate = new Date();
      minDate.setDate(minDate.getDate() - 3);
      return minDate.toLocaleDateString('fr-ca') + ' ' + minDate.toLocaleTimeString('en-GB');
    },
  },
  watch: {
    '$store.getters.idRouteFlash': async function () {
      if (this.$store.getters.idRouteFlash !== null && this.$route.name === 'RouteBoard' && !this.isButtonClicked) {
        let idRoute = this.$store.getters.idRouteFlash;
        let modalElement = document.getElementById('route-detail-modal');
        //Verifica si ya hay un modal abierto
        if (modalElement) {
          let idRouteActive = modalElement.outerHTML.split('id de la ruta" id="')[1].split('">')[0];
          //El modal abierto es de una ruta diferente a la que viene?
          if (idRoute !== idRouteActive) {
            //Cierro el modal actual y abro el con la nueva ruta
            document.getElementById('closeModal').click();
            await this.prepareInstantFilter();
            await this.prepareInstantDetail();
          }
        } else {
          //Si no hay modal abierto abre directamente uno con el id de ruta entrante
          await this.prepareInstantFilter();
          await this.prepareInstantDetail();
        }
      }
    },
  },
};
